import { gsap } from '@gsap/shockingly';

const header = {
	ui: {},

	lastScrollTop: window.scrollY,

	init: function() {
		this.bindUI();
		this.bindEvents();
		this.initSubmenuAnimation();
		this.initTimeline();
		this.initScrollingHeader();
	},

	bindUI: function bindUI() {
		this.ui.$window = $(window);
		this.ui.$document = $(document);
		this.ui.$htmlBody = $("html, body");
		this.ui.$wrapper = $(".js-wrapper");

		this.ui.$menuToggle = $(".js-toggle-menu");

		this.ui.$toggleChildMenu = $(".js-menu-children-toggle-parent");
		this.ui.$menuNoChildren = $(".js-menu-no-children");

		this.ui.$toggleChildMenuMobile = $('.js-nav-mobile-drop-link')

		this.ui.$ajax_menuList_item = $('.js-ajax-menuList-item')
	},

	bindEvents: function bindEvents() {
		this.ui.$menuToggle.on('click', this.menuMobile.bind(this));
		this.ui.$toggleChildMenuMobile.on('click', this.handleDropdownMobile.bind(this));

		// si ajax, on ferme le menu mobile
		this.ui.$document.on('ajax_navigation', this.menuMobileClose.bind(this))
	},

	initSubmenuAnimation: function initSubmenuAnimation(){

		const subMenuBtns = document.querySelectorAll('.js-menu-children-toggle-parent');

		subMenuBtns.forEach(btn => {

			const submenuEl = document.querySelector(`.js-menu-child[data-parent-id="${btn.getAttribute('id')}"]`)
			const submenuLayer = submenuEl.querySelector('.js-menu-children-layer');
			const submenuLinks = submenuEl.querySelectorAll('.js-menu-children-link')
			const btnLink = btn.querySelector('.js-menu-children-toggle')
			const timeline = gsap.timeline({ paused: true })

			timeline.set(submenuEl, { display: 'flex' }, 'start')
				    .from(submenuLayer, { scaleY: 0, duration:0.6, ease: "power4.out" }, "start")
					.from(submenuLinks, { y:40, autoAlpha: 0, duration:1, stagger: 0.05, ease: "power3.out" }, "-=0.5")

			btn.addEventListener('mouseenter', () => {
				timeline.timeScale(1).play()
				btnLink.classList.add('active')
			})

			this.ui.$document.on('mouseenter', '.js-wrapper, .js-menu-no-children', (e) => {
				btnLink.classList.remove('active')
				timeline.timeScale(3).reverse()
			})
		})
	},

  menuMobile: function(e) {
		let $this = $(e.currentTarget);

		if($this.hasClass("active")){
			this.menuMobileClose();
		} else {
			this.timeline.timeScale(1).play();

			this.ui.$htmlBody.addClass("disable-scroll");
			this.ui.$menuToggle.addClass("active");
		}
	},

	menuMobileClose: function(e) {
			this.timeline.timeScale(2).reverse();

			this.ui.$htmlBody.removeClass("disable-scroll");
			this.ui.$menuToggle.removeClass("active");

			$('.js-nav-mobile-drop').slideUp();
	},


	handleDropdownMobile: function(e) {
		e.preventDefault();

		const $this = $(e.currentTarget);
		const dropdownEl = $this.parent().find('.js-nav-mobile-drop')

		dropdownEl.slideToggle()
	},

	initTimeline: function(){
		this.timeline = gsap.timeline({paused: true})

		this.timeline.set('.js-nav-mobile', { display: "block" }, "start")
					 .fromTo('.js-nav-mobile', { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3, ease: "Power2.easeOut" }, "start")
					 .to('.js-toggle-menu-icon', { rotation: 45, ease: "Power2.easeOut", duration: 0.3 }, "start")
					 .from('.js-nav-mobile-stagger', { y: 60, autoAlpha: 0, stagger: 0.085, duration: 1, ease: "Power2.easeOut" }, "-=0.2")
	},

	initScrollingHeader: function () {
		const body = document.querySelector('body');
		window.addEventListener('scroll', function handleScroll() {
			if (window.scrollY > this.lastScrollTop || 0) {
				body.classList.add('scrolling-down');
				body.classList.remove('scrolling-up');
			} else if (window.scrollY < this.lastScrollTop) {
				body.classList.add('scrolling-up');
				body.classList.remove('scrolling-down');
			}
			this.lastScrollTop = window.scrollY;
		});
	},
};

export default header;
